<template>
  <PlatformLayout :useOverlay="overlay">
    <v-card rounded width="100%" max-width="1366" class="d-block mx-auto">
      <v-card-title>
        <v-container fluid class="d-flex justify-space-between pa-0">
          <h5 class="text-h5 font-weight-bold text-left">
            {{ userInfo.nombre || "---" }}&nbsp;
            <v-icon large>mdi-account</v-icon>
          </h5>
          <v-btn
            color="accent"
            type="submit"
            form="client-form"
            :disabled="!valid"
          >
            <v-icon>mdi-content-save</v-icon>&nbsp;Guardar
          </v-btn>
        </v-container>
      </v-card-title>
      <v-card-text>
        <v-form
          id="client-form"
          ref="form"
          v-model="valid"
          @submit.prevent="update"
        >
          <v-card outlined>
            <v-card-title class="font-weight-light"
              >Datos del cliente</v-card-title
            >
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    v-model="userInfo.nombre"
                    hint="Nombre completo"
                    :rules="[validations.required]"
                    dense
                  >
                    <template #label>
                      <span>
                        Nombre del cliente
                        <strong class="red--text"> *</strong>
                      </span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col md="6">
                  <v-text-field v-model="userInfo.rfc" label="RFC" dense />
                </v-col>
                <v-col md="6">
                  <v-text-field
                    v-model="userInfo.clave"
                    label="Clave (ID SAP)"
                    dense
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="userInfo.correo"
                    type="email"
                    :rules="[validations.required, validations.email]"
                    dense
                  >
                    <template #label>
                      <span>
                        Email
                        <strong class="red--text"> *</strong>
                      </span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="userInfo.telefono"
                    :rules="[validations.required]"
                    dense
                  >
                    <template #label>
                      <span>
                        Teléfono
                        <strong class="red--text"> *</strong>
                      </span>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <ClienteDescuentos :userInfo="userInfo" />
          <v-card class="mt-4" outlined>
            <v-card-title class="font-weight-light pb-0">
              Cotizaciones
            </v-card-title>
            <v-card-text>
              <CotizacionesLista :clientID="idUser" />
            </v-card-text>
          </v-card>
        </v-form>
      </v-card-text>
    </v-card>
  </PlatformLayout>
</template>

<script>
import PlatformLayout from "@/components/PlatformLayout.vue";
import CotizacionesLista from "@/components/Cotizaciones/CotizacionesLista.vue";
import ClienteDescuentos from "@/components/Cliente/ClienteDescuentos.vue";
import { required, email } from "@/helpers/formHelpers";
import { httpGet } from "@/services/apiService";

export default {
  name: "Cliente",
  components: {
    PlatformLayout,
    CotizacionesLista,
    ClienteDescuentos,
  },
  data() {
    return {
      idUser: null,
      valid: false,
      overlay: false,
      userInfo: {
        nombre: null,
        correo: null,
        telefono: null,
        rfc: null,
        clave: null,
      },
      validations: {
        required,
        email,
      },
    };
  },
  methods: {
    async update() {
      this.$store.dispatch("updateClientData", this.userInfo);
      this.$toasted.show("Cliente actualizado", { type: "success" });
    },
    async get() {
      this.overlay = true;
      const { data } = await httpGet("/clientes/" + this.idUser);

      this.userInfo = {
        id: this.idUser,
        nombre: data?.data?.attributes?.nombre,
        correo: data?.data?.attributes?.correo,
        telefono: data?.data?.attributes?.telefono,
        rfc: data?.data?.attributes?.rfc,
        clave: data?.data?.attributes?.clave,
        descuento_metalicos: data?.data?.attributes?.descuento_metalicos,
        descuento_panel_ternium:
          data?.data?.attributes?.descuento_panel_ternium,
        descuento_isocindu: data?.data?.attributes?.descuento_isocindu,
      };
      this.overlay = false;
    },
  },
  created() {
    this.idUser = this.$route.params?.id;
    this.get();
  },
};
</script>
